<template>
    <div class="container">
        <div v-if="!modifyLoading">
            <div class="box">
                <van-row :gutter="10">
                    <van-col :span="7" class="col-text-right">产品名称:</van-col>
                    <van-col :span="17">{{orderModifyData.productName}}</van-col>
                </van-row>
                <van-row :gutter="10">
                    <van-col :span="7" class="col-text-right">套餐类型:</van-col>
                    <van-col :span="17">{{orderModifyData.menuName}}</van-col>
                </van-row>
                <van-row :gutter="10">
                    <van-col :span="7" class="col-text-right">出发时间:</van-col>
                    <van-col :span="17">{{orderModifyData.startUseDate}}</van-col>
                </van-row>
                <van-row :gutter="10">
                    <van-col :span="7" class="col-text-right">订购数量:</van-col>
                    <van-col :span="17">
                        <div v-for="(item, index) in orderQuantityData" :key="index" style="display:inline-block">
                            <span>{{item.text}}<span v-if="index!==orderQuantityData.length-1">，</span></span>
                        </div>
                    </van-col>
                </van-row>
                <van-row :gutter="10">
                    <van-col :span="7" class="col-text-right">应付总额:</van-col>
                    <van-col :span="17">CNY {{orderModifyData.shouldPay}}</van-col>
                </van-row>
                <van-row :gutter="10">
                    <van-col :span="7" class="col-text-right">已支付:</van-col>
                    <van-col :span="17">CNY {{orderModifyData.actualPay}}</van-col>
                </van-row>
                <van-row :gutter="10">
                    <van-col :span="7" class="col-text-right">待支付:</van-col>
                    <van-col :span="10">CNY <span style="color:#FF3333">{{orderModifyData.toPay}}</span></van-col>
                    <van-col :span="7"><span style="color:#00479C" @click="handleViewMoney">查看明细</span></van-col>
                </van-row>

                <van-row :gutter="10" style="marginTop:10px">
                    <van-col :span="7" class="col-text-right">数量调整:</van-col>
                    <van-col :span="17">
                        <div v-for="(item,index) in showPriceList" :key="index" class="price-list-items">
                            <van-col :span="6" style="textAlign:right">{{item.priceNameText}}</van-col>
                            <van-col :span="18" class="top_nums_box">
                                <img class="nums_reduce" src="@/assets/icons/sub_gray.png" v-if="item.quantity<1" />
                                <img
                                    class="nums_reduce"
                                    src="@/assets/icons/sub_blue.png"
                                    @click="() => item.quantity -= 1"
                                    v-else
                                />
                                <span class="nums_text">{{ item.quantity }}</span>
                                <img
                                    class="nums_reduce"
                                    src="@/assets/order/add_icon.png"
                                    @click="() => item.quantity += 1"
                                />  
                            </van-col>
                        </div>
                    </van-col>
                </van-row>

                <van-row gutter="10" style="paddingRight:8px">
                    <van-col :span="7" class="col-text-right">备注说明:</van-col>
                    <van-col :span="17" style="border:1px solid #AAAAAA">
                        <van-field 
                            v-model="remark"
                            rows="2"
                            autosize
                            type="textarea"
                            placeholder="请输入......"
                            :border="true"
                        />
                    </van-col>
                </van-row>  
            </div>
            

            <div class="btns-action">
                <van-button round block type="info" class="save" @click="toSave(false)">保存修改</van-button>
                <van-button
                    round
                    block
                    native-type="submit"
                    class="pay"
                    @click="toSave(true)"
                >保存并支付</van-button>
                <van-button class="cancel" type="default" @click="toCancel">取消</van-button>
            </div>
        </div>

        <div v-else class="loading-box">
            <van-loading type="spinner" />
        </div>
        

        <van-popup
            v-model="showPop"
            closeable
            round
            position="bottom"
            :style="{ height: '33%' }"
        >
            <div class="bill-container">
               <div class="bill-header">
                    <span class="menu-name">{{orderModifyData.menuName}}</span>
                    <span class="total-money">小计：¥{{totalMoney}}</span>
                </div> 
                <div class="bill-table">
                    <van-row :gutter="10" v-for="(item, index) in showPriceList" :key="index" style="marginBottom:4px">
                        <van-col :span="4" v-if="item.priceType!==99">¥{{item.distributionPrice}}</van-col>
                        <van-col v-else :span="4">¥{{item.roomDiffPrice}}</van-col>
                        <van-col :span="2">x{{item.quantity}}</van-col>
                        <van-col :span="8">{{item.priceName}}</van-col>
                    </van-row>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import Big from 'big.js'
import { Dialog } from 'vant';
export default {
    name: "line-order-modify",
    data() {
        return {
            showPop: false,
            remark: '', // 备注
        }
    },
    computed: {
        ...mapState('order/vacation', [
            'orderModifyData',
            'orderQuantityData',
            'showPriceList',
            'modifyLoading'
        ]),
        totalMoney() {
            let totalMoney = this.showPriceList.reduce((total, item) => {
                let price = 0;
                if (item.priceType !== 99) {
                    // price = this.showBrokerage ? item.distributionPrice : item.marketPrice;
                    price = item.distributionPrice;
                } else {
                    price = item.roomDiffPrice
                }
                const timesResult = Big(price).times(item.quantity).toNumber();
                total = Big(total).plus(timesResult).toNumber();
                return total;
            }, 0);
            return totalMoney
        }
    },
    async mounted() {
        if (this.$route.query.orderId) {
            await this.setVacationOrderId(this.$route.query.orderId)
            await this.fetchProductsPriceType()
            await this.fetchOrdersModify()
        }
    },
    methods: {
        ...mapMutations('order/vacation', [
            'setVacationOrderId'
        ]),
        ...mapActions('order/vacation', [
            'fetchOrdersModify',
            'fetchProductsPriceType',
            'postSaveOrdersModify'
        ]),
        // 查看费用明细
        handleViewMoney() {
            this.showPop = true
        },
        toSave(payFlag) {
            Dialog.confirm({
                title: "操作提示",
                message: "是否确认修改游客数量？"
            }).then(() => {
                var detailsTemp = this.showPriceList.map(item => {
                    return {
                        priceType: item.priceType,
                        quantity: item.quantity,
                    }
                }).filter(el => el.quantity !== 0)
                var roomQuantity = detailsTemp.filter(item => item.priceType == 99)[0]?.quantity
                var detailsData = detailsTemp.filter(item => item.priceType !== 99)
                var data = {
                    roomQuantity,
                    details: detailsData,
                    remark: this.remark
                };
                this.postSaveOrdersModify({data, payFlag, router: this.$router})
            }).catch(() => {})
        },
        toCancel() {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    background-color: #f4f6f9;
    font-size: vw(32);
    padding-right: vw(20);
    padding-left: vw(20);
    height: 100vh;
    .box {
        background-color: #ffffff;
        height: 100vh;
    }
    .col-text-right {
        text-align: right;
    }
}

.bill-container {
    padding: vw(86) vw(20) vw(20) vw(20);
    .bill-header {
		display: flex;
		justify-content: space-between;

		.menu-name {
			max-width: 65%;

			font-size: vw(32);
			font-weight: bold;
			line-height: 22px;

			color: #333333;
		}

		.total-money {
			font-size: vw(32);
			font-weight: bold;
			line-height: 22px;
			text-align: right;

			color: #FF4A4A;
		}
	}
    
}
.price-list-items {
    display: flex;
    align-items: center;
    margin-bottom: vw(10);
    .top_nums_box {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: vw(30);
        .nums_reduce {
        width: vw(48);
        height: vw(48);
        }
        .nums_text {
        margin-left: vw(28);
        margin-right: vw(28);
        color: #333333;
        font-size: vw(30);
        font-weight: bold;
        }
    }
}
.btns-action {
    display: flex;
    height: vw(110);
    position: fixed;
    bottom: 0;
	left: 0;
	right: 0;
    flex-direction: row;
    align-items: center;
    background-color: #ffffff;
    justify-content: flex-end;
    .save {
        margin-right: vw(15);
		width: vw(200);
		height: vw(80);
		border-radius: vw(8);
		color: #ffffff;
		font-size: vw(30);
		font-weight: bold;
		line-height: vw(80);
		text-align: center;
    }
    .pay {
        margin-right: vw(15);
		width: vw(240);
		height: vw(80);
		background: linear-gradient(to right, #ff8433, #ff3530);
		border-radius: vw(8);
		color: #ffffff;
		font-size: vw(30);
		font-weight: bold;
		line-height: vw(80);
		text-align: center;
    }
    .cancel {
        margin-right: vw(25);
        width: vw(150);
		height: vw(80);
        border-radius: vw(8);
        font-size: vw(30);
		font-weight: bold;
		line-height: vw(80);
		text-align: center;
    }
}
.loading-box {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

</style>